/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'
import { Paper, Typography, CircularProgress, Snackbar, IconButton, Button, Backdrop } from '@material-ui/core'

import MuiAlert from '@material-ui/lab/Alert';

import GroupSpace from './Spaces/GroupSpace'
import RecoSpace from './Spaces/RecoSpace'
import FieldSpace from './Spaces/FieldSpace'
import SingletonSpace from './Spaces/SingletonSpace';

import Actions from '../../../fluid/Actions/ActionFactory'

import MergeGroupsAction  from './components/FloatingActions/MergeGroupsAction';
import MergeGroup from './components/FloatingActions/MergeGroup'

import FieldSimilarityAction from './components/FloatingActions/FieldSimilarityAction';
import FieldSimilarity from './components/FloatingActions/FieldSimilarity';

import SearchBox from './components/UtilComps/SearchBox';
import NewGroup from './components/UtilComps/NewGroup';
import DeleteGroup from './components/UtilComps/DeleteGroup';
import Checkpoints from './components/UtilComps/Checkpoints';

import api_confs from './config/APIConf';
import { Clear } from '@material-ui/icons';
import Action from '../../../fluid/Actions/ActionFactory';
import zIndex from '@material-ui/core/styles/zIndex';

var toPX = require("to-px");
const clone = require('rfdc')()

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({

})

class Report extends Component {
    state = {
        viewport_y : null,
        viewport_height : null,
        report_info : null,
        loading_report_info : false,
        report_info_error : false,
        loading_global_fields : false,
        loading_global_fields_error : false,
        low_count_drops : [],
        global_fields : [],
        global_field_in_focus : null,
        similar_to_global_field_in_focus : null,
        mapping_global_field : null,
        group_filter : {
            direction : 'asc',
            count : null,
            range : {
                lower : null,
                upper : null
            },
            sort_by : 'Name'
        },
        loading_groups : false,
        loading_groups_error : false,
        groups : null,
        pinned_groups : [],
        group_in_focus : null,
        group_in_focus_from : null,
        similar_to_group_in_focus : null,
        similar_to_group_filter : {
            direction : 'asc',
            count : null,
            range : {
                lower : null,
                upper : null
            },
            sort_by : 'Name'
        },
        similar_group_in_focus : null,
        error_loading_similar_group : false,
        field_in_focus : null,
        similar_to_field_in_focus : null,
        similar_field_in_focus : null,
        similar_field_in_focus_type : null,
        singleton_in_focus : null,
        singleton_filter : {
            direction : 'asc',
            count : null,
            range : {
                lower : null,
                upper : null
            },
            sort_by : 'Name'
        },
        search_term : null,
        search_entities : null,
        search_results : null,
        space_states : ['group_list', null, null, null],
        moving_field_from : null,
        moving_field_to : null,
        moving_field : null,
        syncing_field_move : false,
        syncing_field_move_error : false,
        syncing_field_complete : false,
        backdrop_enable : false,
        unsynced_fields : [],
        workspace_refreshed : false,
        workspace_refreshing : false,
        workspace_refresh_error : false,
        syncing_field : null,
        checking_field_similarity : false,
        field_similarity_col_indices : null,
        checking_merge_groups : false,
        show_new_group : false,
        new_group : {
            group_id : null,
            fields : [],
        },
        creating_new_group : false,
        new_group_error : false,
        new_group_error_message : "",
        deleting_group : null,
        show_checkpoints : false
    }

    header = React.createRef()
    auto_checkpoint
    
    componentDidUnmount () {
        document.removeEventListener('click')
    }
 
    componentDidMount () {
        document.addEventListener('click', e => {
            if (this.state.workspace_refreshing === true) {
                e.stopPropagation();
                e.preventDefault();
            }
        }, true)
        console.log("IFC :: Opening report ffor IC: " + this.props.ic_name + " and version : " + this.props.version)
        let bounding_rect = this.header.current.getBoundingClientRect()
        console.log("IFC :: Bounding Rect : ", bounding_rect)
        let viewport_y = bounding_rect.bottom
        let viewport_height = toPX('100vh') - viewport_y
        this.setState({...this.state, viewport_height : viewport_height - 2, viewport_y : viewport_y, loading_report_info : true, report_info_error : false}, () => {
            Actions("http_request", {
                url: "/sainapse/ifc/report_info",
                method : "post",
                data : {
                    ic_name : this.props.ic_name,
                    version : this.props.version
                }
            }).then(res => {
                // let group_filter = {
                //     direction : null,
                //     count : null,
                //     range : {
                //         lower : null,
                //         upper : null
                //     },
                //     sort_by : 'score'
                // }

                // if (res.data.result.Result.report_summary.num_field_groups.value < 25) {
                //     group_filter.direction = "All"
                // } else {
                //     group_filter.direction = "Top"
                //     group_filter.count = 25
                // }
                this.setState({...this.state, loading_report_info : false, report_info_error : false, report_info : res.data.result.Result}, () => {
                    console.log("IFC :: Received Report Info : ", this.state)
                    this.getLowCountDrops(() => this.getGlobalFields(() => this.getGroups()))
                })
                console.log("IFC :: Report Info : ", res.data)
            }).catch(err => {
                this.setState({...this.state, loading_report_info : false, report_info_error : true})
            })
        })

        this.auto_checkpoint = setInterval(() => {
            Actions('http_request', {
                url : "/sainapse/ifc/add_checkpoint",
                method : "post",
                data : {
                    checkpoint_type: "Auto",
                    comments: "Auto Checkpoint",
                    ic_name: this.props.ic_name,
                    name: null,
                    version: this.props.version
                }
            })
        }, 1800000)
    }

    componentWillUnmount () {
        clearInterval(this.auto_checkpoint)
    }

    refreshReportInfo = (chained_func) => {
        this.setState({...this.state, loading_report_info : true, report_info_error : false }, () => {
            Actions("http_request", {
                url: "/sainapse/ifc/report_info",
                method : "post",
                data : {
                    ic_name : this.props.ic_name,
                    version : this.props.version
                }
            }).then(res => {
                this.setState({...this.state, loading_report_info : false, report_info : res.data.result.Result}, () => {
                    if (chained_func) {
                        chained_func()
                    }
                })
                console.log("IFC :: Report Info : ", res.data)
            }).catch(err => {
                this.setState({...this.state, loading_report_info : false, report_info_error : true})
            })
        })
    }

    refreshReportAndData = () => {
        let refresh_action_list = ['get_global_fields', 'get_groups']
            
        if (this.state.group_in_focus !== null) {
            let required_actions = ['get_group_in_focus', 'get_nearby_groups_for_group', 'get_nearby_fields_for_group']
            refresh_action_list = [...refresh_action_list, ...required_actions]
        }

        if (this.state.field_in_focus !== null) {
            let required_actions = ['get_nearby_groups_for_field', 'get_nearby_fields_for_field']
            refresh_action_list = [...refresh_action_list, ...required_actions]
        }

        if (this.state.search_results !== null) {
            let required_actions = ['search']
            refresh_action_list = [...refresh_action_list, ...required_actions]
        }
        this.refreshReportInfo(() => this.refreshData(refresh_action_list))
    }

    updateState = (state_change, chained_func) => {
        this.setState({...this.state, ...state_change}, () => {
            console.log("IFC :: State Update call from Children : ", state_change)
            console.log("IFC :: State Updated from Children : ", this.state)
            if (chained_func) {
                chained_func()
            }
        })
    }

    updateSpaceState = (index, state) => {
        let new_space_states = [...this.state.space_states]
        new_space_states[index] = state

        if (new_space_states[0] === 'group_list') {
            console.log("IFC :: Forcing (2) to null")
            new_space_states[2] = null
        }

        this.setState({...this.state, space_states : new_space_states}, () => console.log("IFC :: Space States : ", this.state.space_states))
    }

    renderSpaces = () => {
        if (this.state.report_info !== null) {
            return (
                <div style = {{
                    width : '100%', 
                    height : this.state.viewport_height + "px", 
                    display : 'flex',
                    flexDirection : 'row'
                }}>
                    <div style = {{width : '25%', height : '100%', borderRight : '1px solid rgba(0,0,0,0.12)', backgroundColor : '#F5F5F5'}}>
                        <GroupSpace 
                            column_index = {0}
                            space_height = {this.state.viewport_height} 
                            ic_name = {this.props.ic_name} 
                            version = {this.props.version} 
                            global_field_display_name = {this.props.global_field_display_name}
                            group_display_name = {this.props.group_display_name}
                            field_display_name = {this.props.field_display_name}
                            report_info = {this.state.report_info}
                            refresh_report_and_data = {this.refreshReportAndData}
                            low_count_drops = {this.state.low_count_drops}
                            global_fields = {this.state.global_fields}
                            mapping_global_field = {this.state.mapping_global_field}
                            map_global_field = {(entity_id, global_field) => this.mapGlobalField(entity_id, global_field)}
                            create_global_field = {(entity_id, new_field_name) => this.createGlobalField(entity_id, new_field_name)}
                            global_fields_error = {this.state.loading_global_fields_error}
                            group_filter = {this.state.group_filter}
                            update_filter = {(group_filter) => this.updateFilter(group_filter)}
                            loading_groups = {this.state.loading_groups}
                            loading_groups_error = {this.state.loading_groups_error}
                            get_groups = {(group_id, from) => this.getGroups(group_id, from)}
                            groups = {this.state.groups}
                            pinned_groups = {this.state.pinned_groups}
                            group_in_focus = {this.state.group_in_focus}
                            group_in_focus_from = {this.state.group_in_focus_from}
                            pin_group = {(group_id, action) => this.pinGroup(group_id, action)}
                            focus_group = {(group_object, from, chained_func) => this.focusGroup(group_object, from, chained_func)}
                            field_in_focus = {this.state.field_in_focus}
                            focus_field = {(field_object, field_type, chained_func) => this.focusField(field_object, field_type, chained_func)}
                            global_field_in_focus = {this.state.global_field_in_focus}
                            focus_global_field = {(global_field_name, chained_func) => this.focusGlobalField(global_field_name, chained_func)}
                            update_space_state = {(index, state) => this.updateSpaceState(index, state)}
                            move_field = {(field_data, field_type, drop_result) => this.moveField(field_data, field_type, drop_result)}
                            syncing_field = {this.state.syncing_field}
                            unsynced_fields = {this.state.unsynced_fields}
                            create_new_group_from_field = {(field_data) => this.createNewGroupFromField(field_data)}
                            make_singleton = {(field_data) => this.makeFieldSingleton(field_data)}
                            delete_group = {(group_data) => this.deleteGroup(group_data)}
                            checking_merge_groups = {this.state.checking_merge_groups}
                            update_state = {(state, chained_func) => this.updateState(state, chained_func)}
                        />
                    </div>
                    <div style = {{width : '25%', height : '100%', borderRight : '1px solid rgba(0,0,0,0.12)', backgroundColor : '#F5F5F5'}}>
                        <RecoSpace
                            column_index = {1}
                            space_height = {this.state.viewport_height} 
                            ic_name = {this.props.ic_name} 
                            version = {this.props.version} 
                            global_field_display_name = {this.props.global_field_display_name}
                            group_display_name = {this.props.group_display_name}
                            field_display_name = {this.props.field_display_name}
                            report_info = {this.state.report_info}
                            refresh_report_and_data = {this.refreshReportAndData}
                            global_fields = {this.state.global_fields}
                            create_global_field = {(entity_id, new_field_name) => this.createGlobalField(entity_id, new_field_name)}
                            mapping_global_field = {this.state.mapping_global_field}
                            map_global_field = {(entity_id, global_field) => this.mapGlobalField(entity_id, global_field)}
                            get_groups = {() => this.getGroups()}
                            groups = {this.state.groups}
                            pinned_groups = {this.state.pinned_groups}
                            pin_group = {(group_id, action) => this.pinGroup(group_id, action)}
                            group_in_focus = {this.state.group_in_focus}
                            similar_to_group_in_focus = {this.state.similar_to_group_in_focus}
                            similar_to_group_filter = {this.state.similar_to_group_filter}
                            update_filter = {(filter) => this.setState({...this.state, similar_to_group_filter: filter})}
                            similar_group_in_focus = {this.state.similar_group_in_focus}
                            focus_similar_group = {(group_object, chained_func) => this.focusSimilarGroup(group_object, chained_func)}
                            field_in_focus = {this.state.field_in_focus}
                            similar_to_field_in_focus = {this.state.similar_to_field_in_focus}
                            similar_field_in_focus = {this.state.similar_field_in_focus}
                            similar_field_in_focus_type = {this.state.similar_field_in_focus_type}
                            focus_similar_field = {(field_object, field_type, chained_func) => this.focusSimilarField(field_object, field_type, chained_func)}
                            global_field_in_focus = {this.state.global_field_in_focus}
                            similar_to_global_field_in_focus = {this.state.similar_to_global_field_in_focus}
                            search_results = {this.state.search_results}
                            update_space_state = {(index, state) => this.updateSpaceState(index, state)}
                            move_field = {(field_data, field_type, drop_result) => this.moveField(field_data, field_type, drop_result)}
                            syncing_field = {this.state.syncing_field}
                            checking_field_similarity = {this.state.checking_field_similarity}
                            field_similarity_col_indices = {this.state.field_similarity_col_indices}
                            unsynced_fields = {this.state.unsynced_fields}
                            create_new_group_from_field = {(field_data) => this.createNewGroupFromField(field_data)}
                            make_singleton = {(field_data) => this.makeFieldSingleton(field_data)}
                            delete_group = {(group_data) => this.deleteGroup(group_data)}
                            checking_merge_groups = {this.state.checking_merge_groups}
                            update_state = {(state, chained_func) => this.updateState(state, chained_func)}
                            close_field_similarity = {() => this.setState({...this.state, checking_field_similarity : false, field_similarity_col_indices : null })}
                        />
                    </div>
                    <div style = {{width : '25%', height : '100%', borderRight : '1px solid rgba(0,0,0,0.12)', backgroundColor : '#F5F5F5'}}>
                        <FieldSpace
                            column_index = {2}
                            space_height = {this.state.viewport_height} 
                            ic_name = {this.props.ic_name} 
                            version = {this.props.version} 
                            global_field_display_name = {this.props.global_field_display_name}
                            group_display_name = {this.props.group_display_name}
                            field_display_name = {this.props.field_display_name}
                            report_info = {this.state.report_info}
                            refresh_report_and_data = {this.refreshReportAndData}
                            global_fields = {this.state.global_fields}
                            mapping_global_field = {this.state.mapping_global_field}
                            map_global_field = {(entity_id, global_field) => this.mapGlobalField(entity_id, global_field)}
                            global_fields_error = {this.state.loading_global_fields_error}
                            group_in_focus = {this.state.group_in_focus}
                            field_in_focus = {this.state.field_in_focus}
                            unfocus_field = {(field_object) => this.focusField(null, null, () => this.updateSpaceState(2, null))}
                            update_space_state = {(index, state) => this.updateSpaceState(index, state)}
                            checking_field_similarity = {this.state.checking_field_similarity}
                            field_similarity_col_indices = {this.state.field_similarity_col_indices}
                            update_state = {(state, chained_func) => this.updateState(state, chained_func)}
                            close_field_similarity = {() => this.setState({...this.state, checking_field_similarity : false, field_similarity_col_indices : null })}
                        />
                    </div>
                    <div style = {{width : '25%', height : '100%', borderRight : '1px solid rgba(0,0,0,0.12)', backgroundColor : '#F5F5F5'}}>
                        <SingletonSpace
                            column_index = {3}
                            location = {'Singleton'}
                            group_in_focus = {this.state.group_in_focus}
                            ic_name = {this.props.ic_name}
                            version = {this.props.version}
                            global_field_display_name = {this.props.global_field_display_name}
                            group_display_name = {this.props.group_display_name}
                            field_display_name = {this.props.field_display_name}
                            report_info = {this.state.report_info}
                            global_fields = {this.state.global_fields}
                            create_global_field = {(entity_id, new_field_name) => this.createGlobalField(entity_id, new_field_name)}
                            mapping_global_field = {this.state.mapping_global_field}
                            map_global_field = {(entity_id, global_field) => this.mapGlobalField(entity_id, global_field)}
                            global_fields_error = {this.state.loading_global_fields_error}
                            space_height = {this.state.viewport_height} 
                            move_field = {(field_data, field_type, drop_result) => this.moveField(field_data, field_type, drop_result)}
                            syncing_field = {this.state.syncing_field}
                            unsynced_fields = {this.state.unsynced_fields}
                            update_space_state = {(index, state) => this.updateSpaceState(index, state)}
                            create_new_group_from_field = {(field_data) => this.createNewGroupFromField(field_data)}
                            checking_field_similarity = {this.state.checking_field_similarity}
                            field_similarity_col_indices = {this.state.field_similarity_col_indices}
                            update_state = {(state, chained_func) => this.updateState(state, chained_func)}
                            refresh_data = {() => this.refreshReportAndData()}
                            singleton_filter = {this.state.singleton_filter}
                            update_filter = {(singleton_filter) => this.updateSingletonFilter(singleton_filter)}
                            search_label = {"Search All Singletons"}
                            backdrop_enabler = {(backdrop_enable) => this.setState({...this.state, backdrop_enable : backdrop_enable})}
                            close_field_similarity = {() => this.setState({...this.state, checking_field_similarity : false, field_similarity_col_indices : null })}
                            />
                    </div>
                </div>
            )
        } else {
            if (this.state.loading_report_info) {
                return (
                    <div style = {{
                        width : '100%', 
                        height : this.state.viewport_height + "px", 
                        display : 'flex',
                        flexDirection : 'row',
                        justifyContent : 'center',
                        alignItems : 'center'
                    }}>
                        <CircularProgress variant = 'indeterminate' color = 'primary'/>
                    </div>
                )
            } else if (this.state.report_info_error) {
                return (
                    <div style = {{
                        width : '100%', 
                        height : this.state.viewport_height + "px", 
                        display : 'flex',
                        flexDirection : 'row',
                        justifyContent : 'center',
                        alignItems : 'center'
                    }}>
                        <Paper style = {{
                            width : '40%', 
                            height : '20%', 
                            padding : '10px', 
                            display : 'flex', 
                            flexDirection : 'row',
                            justifyContent : 'center',
                            alignItems : 'center'
                        }}>
                            <Typography variant = 'body2' color = 'secondary' align = 'center'>Error loading report information.</Typography>
                        </Paper>
                    </div>
                )
            }
        }
    }

    mapGlobalField = (entity_id, global_field) => {
        this.setState({...this.state, mapping_global_field : global_field, backdrop_enable : true}, () => {
            Actions('http_request', {
                url : "/sainapse/ifc/change_mapping",
                method : "post",
                data : {
                    entity : entity_id,
                    global_field : global_field !== null ? global_field.global_field : null,
                    ic_name : this.props.ic_name,
                    version : this.props.version
                }
            }).then(res => {
                this.setState({...this.state, mapping_global_field : null}, () => {
                    let refresh_action_list = ['get_global_fields', 'get_groups']
            
                    if (this.state.group_in_focus !== null) {
                        let required_actions = ['get_group_in_focus', 'get_nearby_groups_for_group', 'get_nearby_fields_for_group']
                        refresh_action_list = [...refresh_action_list, ...required_actions]
                    }
        
                    if (this.state.field_in_focus !== null) {
                        let required_actions = ['get_nearby_groups_for_field', 'get_nearby_fields_for_field']
                        refresh_action_list = [...refresh_action_list, ...required_actions]
                    }
        
                    if (this.state.search_results !== null) {
                        let required_actions = ['search']
                        refresh_action_list = [...refresh_action_list, ...required_actions]
                    }
                    this.refreshReportInfo(() => this.refreshData(refresh_action_list))
                })
            })
        })
    }

    createGlobalField = (entity_id, new_field_name) => {
        this.setState({...this.state, backdrop_enable : true}, () => {
            Actions('http_request', {
                url : "/sainapse/ifc/add_global_field",
                method : "post",
                data : {
                    global_field_name : new_field_name,
                    mapping : entity_id,
                    ic_name : this.props.ic_name,
                    version : this.props.version
                }
            }).then(res => {
                let refresh_action_list = ['get_global_fields', 'get_groups']
            
                    if (this.state.group_in_focus !== null) {
                        let required_actions = ['get_group_in_focus', 'get_nearby_groups_for_group', 'get_nearby_fields_for_group']
                        refresh_action_list = [...refresh_action_list, ...required_actions]
                    }
        
                    if (this.state.field_in_focus !== null) {
                        let required_actions = ['get_nearby_groups_for_field', 'get_nearby_fields_for_field']
                        refresh_action_list = [...refresh_action_list, ...required_actions]
                    }
        
                    if (this.state.search_results !== null) {
                        let required_actions = ['search']
                        refresh_action_list = [...refresh_action_list, ...required_actions]
                    }
    
                    this.refreshReportInfo(() => this.refreshData(refresh_action_list))
            })
        })
    }

    updateFilter = (group_filter) => {
        this.setState({...this.state, group_filter : group_filter})
    }

    updateSingletonFilter = (singleton_filter) => {
        this.setState({...this.state, singleton_filter : singleton_filter})
    }

    getGlobalFields = (chained_func) => {
        this.setState({...this.state, loading_global_fields : true, loading_global_fields_error : null, global_fields: []}, () => {
            Actions('http_request', {
                url : "/sainapse/ifc/global_schema_fields",
                method : "post",
                data : {
                    field_type : "all",
                    version : this.props.version,
                    ic_name : this.props.ic_name,
                    lower_idx : 0,
                    upper_idx : this.state.report_info.report_summary.num_global_fields.value
                }
            }).then(res => {
                this.setState({...this.state, loading_global_fields : false, loading_global_fields_error : null, global_fields : res.data.result.Result }, () => {
                    if (chained_func) {
                        chained_func()
                    }
                })
            })
        })
    }

    getLowCountDrops = (chained_func) => {
        this.setState({...this.state, low_count_drops : []}, () => {
            Actions('http_request', {
                url : "/sainapse/ifc/get_dropped_fields",
                method : "post",
                data : {
                    ic_name : this.props.ic_name,
                }
            }).then(res => {
                this.setState({...this.state, low_count_drops : res.data.result.Result }, () => {
                    if (chained_func) {
                        chained_func()
                    }
                })
            })
        })
    }

    getRange = () => {
        let lower_index
        let upper_index

        if (this.state.group_filter.direction === "All") {
            lower_index = 0
            upper_index = this.state.report_info.report_summary.num_field_groups.value
        }

        if (this.state.group_filter.direction === "Top") {
            lower_index = 0
            upper_index = this.state.group_filter.count
        }

        if (this.state.group_filter.direction === "Bottom") {
            lower_index = this.state.report_info.report_summary.num_field_groups.value - this.state.group_filter.count
            upper_index = this.state.report_info.report_summary.num_field_groups.value
        }

        if (this.state.group_filter.direction === "Range") {
            lower_index = this.state.group_filter.range.lower
            upper_index = this.state.group_filter.range.upper
        }

        let range = [lower_index, upper_index]
        return range
    }

    getGroups = (group_id, from) => {
        this.setState({...this.state, loading_groups : true, loading_groups_error : false}, () => {
            // console.log("IFC :: Range: ", this.getRange())
            // let lower_index = this.getRange('group_filter')[0]
            // let upper_index = this.getRange()[1]

            // console.log("IFC :: Getting Groups from " + lower_index + " to " + upper_index)
            Actions('http_request', {
                url : "/sainapse/ifc/groups",
                method : "post",
                data : {
                    ic_name : this.props.ic_name,
                    sort_by : 'score',
                    version : this.props.version,
                    lower_idx : 0,
                    upper_idx : this.state.report_info.report_summary.num_field_groups.value
                }
            }).then(res => {
                console.log("IFC :: Groups : ", res.data)
                this.setState({...this.state, loading_groups : false, loading_groups_error : false, groups : res.data.result.Result}, () => {
                    console.log("IFC :: Groups Fetched : ", this.state)
                    if (group_id) {
                        let group = this.state.groups.find(group => group_id === group.group_id)
                        if (group) {
                            this.focusGroup(group, from)
                        }
                    }
                })
            }).catch(err => {
                this.setState({...this.state, loading_groups : false, loading_groups_error : true})
            })
        })
    }

    pinGroup = (group_id, action) => {
        let pinned_groups = [...this.state.pinned_groups]

        if (action === "unpin") {
            let group_idx = pinned_groups.findIndex(pinned_group_id => pinned_group_id === group_id)
            pinned_groups.splice(group_idx, 1)
        } else if (action === "pin") {
            pinned_groups.push(group_id)
        }

        this.setState({...this.state, pinned_groups : pinned_groups})
    }

    focusGroup = (group_object, from, chained_func) => {
        console.log("IFC :: Focussing Group : ", group_object)
        let should_field_unfocus = true
        let space_states = this.state.space_states
        let checking_field_similarity = this.state.checking_field_similarity
        if (this.state.group_in_focus) {
            if (group_object) {
                if (this.state.group_in_focus.group_id === group_object.group_id) {
                    should_field_unfocus = false
                } else {
                    should_field_unfocus = true
                }
            } else {
                should_field_unfocus = true
                space_states[2] = null
                checking_field_similarity = false
            }
        }

        this.setState({...this.state, 
            group_in_focus : group_object, 
            group_in_focus_from : from, 
            field_in_focus : should_field_unfocus ? null : this.state.field_in_focus, 
            similar_to_group_in_focus : null,
            global_field_in_focus : group_object !== null ? group_object.global_mapped_field : null,
            similar_to_global_field_in_focus : group_object !== null ? this.state.similar_to_global_field_in_focus : null,
            space_states : space_states,
            checking_field_similarity : checking_field_similarity
        }, () => {
            if (group_object !== null) {
                let request_actions = [
                    {
                        url : "/sainapse/ifc/nearby_groups_for_group",
                        method : "post",
                        data : {
                            group_id : this.state.group_in_focus.group_id,
                            ic_name : this.props.ic_name,
                            version : this.props.version,
                            top_k : 25
                        }
                    },
                    {
                        url : "/sainapse/ifc/nearby_fields_for_group",
                        method : "post",
                        data : {
                            group_id : this.state.group_in_focus.group_id,
                            ic_name : this.props.ic_name,
                            version : this.props.version,
                            top_k : 25
                        }
                    }
                ]

                if (this.state.global_field_in_focus !== null) {
                    let global_field_actions = [
                        {
                            url : "/sainapse/ifc/nearby_groups_for_field",
                            method : "post",
                            data : {
                                field : this.state.global_field_in_focus,
                                ic_name : this.props.ic_name,
                                version : this.props.version,
                                top_k : 25
                            }
                        },
                        {
                            url : "/sainapse/ifc/nearby_fields_for_field",
                            method : "post",
                            data : {
                                field : this.state.global_field_in_focus,
                                ic_name : this.props.ic_name,
                                version : this.props.version,
                                top_k : 25
                            }
                        }
                    ]

                    request_actions = [...request_actions, ...global_field_actions]
                }

                Actions('http_requests', request_actions).then(res => {
                    console.log("IFC :: Multi Call Results : ", res)
                    let similar_entities = {
                        groups: null,
                        fields : res[1].data.result.Result.nearby_grouped_fields,
                        singletons : res[1].data.result.Result.nearby_singletons,
                        global_fields : res[1].data.result.Result.nearby_global_fields
                    }

                    let similar_groups = {
                        name_similarity : [],
                        value_similarity : [],
                        combined_similarity : []
                    }

                    similar_groups.name_similarity = res[0].data.result.Result.nearby_groups.name_similarity.map(nearby_group => {
                        let group = nearby_group.group
                        group.score = nearby_group.score
                        return group
                    })

                    similar_groups.value_similarity = res[0].data.result.Result.nearby_groups.value_similarity.map(nearby_group => {
                        let group = nearby_group.group
                        group.score = nearby_group.score
                        return group
                    })

                    similar_groups.combined_similarity = res[0].data.result.Result.nearby_groups.combined_similarity.map(nearby_group => {
                        let group = nearby_group.group
                        group.score = nearby_group.score
                        return group
                    })

                    similar_entities.groups = similar_groups

                    let similar_to_global_field_in_focus = null
                    if (this.state.global_field_in_focus !== null) {
                        similar_to_global_field_in_focus = {
                            groups: null,
                            fields : res[3].data.result.Result.nearby_grouped_fields,
                            singletons : res[3].data.result.Result.nearby_singletons,
                            global_fields : res[3].data.result.Result.nearby_global_fields
                        }

                        let similar_groups = {
                            name_similarity : [],
                            value_similarity : [],
                            combined_similarity : []
                        }
    
                        similar_groups.name_similarity = res[2].data.result.Result.nearby_groups.name_similarity.map(nearby_group => {
                            let group = nearby_group.group
                            group.score = nearby_group.score
                            return group
                        })
    
                        similar_groups.value_similarity = res[2].data.result.Result.nearby_groups.value_similarity.map(nearby_group => {
                            let group = nearby_group.group
                            group.score = nearby_group.score
                            return group
                        })
    
                        similar_groups.combined_similarity = res[2].data.result.Result.nearby_groups.combined_similarity.map(nearby_group => {
                            let group = nearby_group.group
                            group.score = nearby_group.score
                            return group
                        })

                        similar_to_global_field_in_focus.groups = similar_groups
                    }
                    
                    this.setState({
                        ...this.state, 
                        similar_to_group_in_focus : similar_entities, 
                        similar_group_in_focus : null,
                        similar_to_global_field_in_focus : similar_to_global_field_in_focus
                    }, () => {
                        if (chained_func) {
                            chained_func()
                        }
                    })
                })
            } else {
                let space_states = [this.space_states]
                space_states[0] = 'group_list'
                space_states[1] = null
                this.setState({...this.state, checking_merge_groups: false, space_states: space_states}, () => {
                    if (chained_func) {
                        chained_func()
                    }
                })
            }
        })
    }

    focusField = (field_object, field_type, chained_func) => {
        this.setState({...this.state, field_in_focus : field_object, similar_to_field_in_focus : null}, () => {
            console.log("IFC :: Focussing Field : ", field_object)
            if (field_object !== null) {
                Actions('http_requests', [
                    {
                        url : "/sainapse/ifc/nearby_groups_for_field",
                        method : "post",
                        data : {
                            field : field_object.field,
                            ic_name : this.props.ic_name,
                            version : this.props.version,
                            top_k : 25
                        }
                    },
                    {
                        url : "/sainapse/ifc/nearby_fields_for_field",
                        method : "post",
                        data : {
                            field : field_object.field,
                            ic_name : this.props.ic_name,
                            version : this.props.version,
                            top_k : 25
                        }
                    }
                ]).then(res => {
                    console.log("IFC :: Similar Entities to Field : ", res)
                    let similar_entities = {
                        groups : null,
                        fields : null,
                        singletons : null,
                        global_fields : null
                    }

                    let similar_groups = {
                        name_similarity : [],
                        value_similarity : [],
                        combined_similarity : []
                    }

                    similar_groups.name_similarity = res[0].data.result.Result.nearby_groups.name_similarity.map(nearby_group => {
                        let group = nearby_group.group
                        group.score = nearby_group.score
                        return group
                    })

                    similar_groups.value_similarity = res[0].data.result.Result.nearby_groups.value_similarity.map(nearby_group => {
                        let group = nearby_group.group
                        group.score = nearby_group.score
                        return group
                    })

                    similar_groups.combined_similarity = res[0].data.result.Result.nearby_groups.combined_similarity.map(nearby_group => {
                        let group = nearby_group.group
                        group.score = nearby_group.score
                        return group
                    })

                    similar_entities.groups = similar_groups

                    // similar_entities.groups = res[0].data.result.Result.nearby_groups.combined_similarity.map(nearby_group => {
                    //     let group = nearby_group.group
                    //     group.score = nearby_group.score
                    //     return group
                    // })

                    similar_entities.fields = res[1].data.result.Result.nearby_grouped_fields
                    similar_entities.singletons = res[1].data.result.Result.nearby_singletons
                    similar_entities.global_fields = res[1].data.result.Result.nearby_global_fields

                    this.setState({...this.state, similar_to_field_in_focus : similar_entities, similar_field_in_focus : null}, () => {
                        if (chained_func) {
                            chained_func()
                        }
                    })
                })
            } else {
                this.setState({...this.state, similar_to_field_in_focus : null, similar_field_in_focus : null, checking_field_similarity : false, field_similarity_col_indices : null}, () => {
                    if (chained_func) {
                        chained_func()
                    }
                })
            }
        })
    }

    focusGlobalField = (global_field_name, chained_func) => {
        this.setState({
            ...this.state,
            global_field_in_focus : global_field_name,
            similar_to_global_field_in_focus : null
        }, () => {
            Actions('http_requests', [
                {
                    url : "/sainapse/ifc/nearby_groups_for_field",
                    method : "post",
                    data : {
                        field : this.state.global_field_in_focus,
                        ic_name : this.props.ic_name,
                        version : this.props.version,
                        top_k : 25
                    }
                },
                {
                    url : "/sainapse/ifc/nearby_fields_for_field",
                    method : "post",
                    data : {
                        field : this.state.global_field_in_focus,
                        ic_name : this.props.ic_name,
                        version : this.props.version,
                        top_k : 25
                    }
                }
            ]).then(res => {
                let similar_to_global_field_in_focus = null
                if (this.state.global_field_in_focus !== null) {
                    similar_to_global_field_in_focus = {
                        groups: null,
                        fields : res[1].data.result.Result.nearby_grouped_fields,
                        singletons : res[1].data.result.Result.nearby_singletons,
                        global_fields : res[1].data.result.Result.nearby_global_fields
                    }

                    let similar_groups = {
                        name_similarity : [],
                        value_similarity : [],
                        combined_similarity : []
                    }

                    similar_groups.name_similarity = res[0].data.result.Result.nearby_groups.name_similarity.map(nearby_group => {
                        let group = nearby_group.group
                        group.score = nearby_group.score
                        return group
                    })

                    similar_groups.value_similarity = res[0].data.result.Result.nearby_groups.value_similarity.map(nearby_group => {
                        let group = nearby_group.group
                        group.score = nearby_group.score
                        return group
                    })

                    similar_groups.combined_similarity = res[0].data.result.Result.nearby_groups.combined_similarity.map(nearby_group => {
                        let group = nearby_group.group
                        group.score = nearby_group.score
                        return group
                    })

                    similar_to_global_field_in_focus.groups = similar_groups

                    // similar_to_global_field_in_focus.groups = res[0].data.result.Result.nearby_groups.combined_similarity.map(nearby_group => {
                    //     let group = nearby_group.group
                    //     group.score = nearby_group.score
                    //     return group
                    // })
                }

                this.setState({...this.state, similar_to_global_field_in_focus : similar_to_global_field_in_focus}, () => {
                    if (chained_func) {
                        chained_func()
                    }
                })
            })
        })
    }

    focusSimilarGroup = (group_object, chained_func) => {
        if (group_object) {
            this.setState({...this.state, similar_group_in_focus : null, error_loading_similar_group : false}, () => {
                Actions('http_request', {
                    url : "/sainapse/ifc/groups_by_id",
                    method : "post",
                    data : {
                        ic_name : this.props.ic_name,
                        version : this.props.version,
                        group_ids : [group_object.group_id]
                    }
                }).then(res => {
                    let selected_group = res.data.result.Result[0]
                    this.setState({...this.state, similar_group_in_focus : selected_group, error_loading_similar_group : false}, () => {
                        chained_func()
                    })
                }).catch(err => {
                    this.setState({...this.state, similar_group_in_focus : group_object, error_loading_similar_group : true}, () => {
                        chained_func()
                    })
                })
            })
        } else {
            this.setState({...this.state, similar_group_in_focus : group_object, error_loading_similar_group : false, checking_merge_groups : false}, () => {
                chained_func()
            })
        }  
    }

    focusSimilarField = (field_object, field_type, chained_func) => {
        this.setState({...this.state, similar_field_in_focus : field_object, similar_field_in_focus_type : field_type}, () => {
            chained_func()
        })
    }

    moveField = (field_data, field_type, drop_result) => {
        console.log("IFC :: Moving Field")
        console.log("IFC :: Type : ", field_type)
        console.log("IFC :: From : ", field_data)
        console.log("IFC :: To: ", drop_result)

        let refresh_required = true

        let from_space = field_data.location
        let to_space = drop_result.location

        let from_group
        let to_group

        let new_group_involved = false
        if (field_data.location === 'NewGroup') {
            new_group_involved = true
        }

        if (drop_result.location === 'NewGroup') {
            new_group_involved = true
        }

        if (field_data.field_data.group_id === drop_result.group_data.group_id) {
            return
        }

        let prev_state = clone(this.state)
        let new_state = clone(this.state)
        
        if (field_data.location === 'NewGroup') {
            from_group = new_state.new_group
        } else {
            from_group = new_state.groups.find(group => group.group_id === field_data.field_data.group_id)
        }

        if (drop_result.location === 'NewGroup') {
            to_group = new_state.new_group
        } else {
            to_group = new_state.groups.find(group => group.group_id === drop_result.group_data.group_id)
        }

        if (from_group) {
            if (drop_result.location === "NewGroup") {
                refresh_required = false
                new_state.unsynced_fields.push(field_data.field_data.field)
                to_group.fields.push(field_data)
            } else {
                let field_index = from_group.fields.findIndex(field => field === field_data.field_data.field)
                from_group.fields.splice(field_index, 1)
                to_group.fields.push(field_data.field_data.field)
                to_group.field_scores.push(field_data.field_data.score)
            }
        } else {
            if (drop_result.location === "NewGroup") {
                refresh_required = false
                new_state.unsynced_fields.push(field_data.field_data.field)
                to_group.fields.push(field_data)
            } else {
                to_group.fields.push(field_data.field_data.field)
                to_group.field_scores.push(field_data.field_data.score)
            }   
        }

        if (from_space === 'GroupSpace') {
            new_state.group_in_focus = from_group
        } else if (from_space === 'RecoSpace') {
            new_state.similar_group_in_focus = from_group
        } else if (from_space === 'NewGroup') {
            new_state.new_group = from_group
        }

        if (to_space === 'GroupSpace') {
            new_state.group_in_focus = to_group
        } else if (to_space === 'RecoSpace') {
            new_state.similar_group_in_focus = to_group
        } else if (from_space === 'NewGroup') {
            new_state.new_group = from_group
        }

        if (!new_group_involved) {
            new_state.syncing_field_move  = true 
            new_state.backdrop_enable = true
            new_state.syncing_field_move_error = false
            new_state.syncing_field_complete = false
            new_state.syncing_field = field_data.field_data.field
        }
        console.log("IFC :: State pre moving field : ", new_state)

        this.setState({
            ...new_state, 
            moving_field_from : field_data, 
            moving_field : field_data.field_data.field, 
            moving_field_to : drop_result, 
            
            workspace_refreshed : false
         }, () => {
            if (refresh_required) {
                console.log("IFC :: State post moving field : ", this.state)
                Actions('http_request', {
                    url : "/sainapse/ifc/update_groups",
                    method : "post",
                    data : {
                        ic_name : this.props.ic_name,
                        version : this.props.version,
                        updates : [
                            {
                                from : field_data.field_data.group_id,
                                name : field_data.field_data.field,
                                to : drop_result.group_data.group_id
                            }
                        ]
                    }
                }).then(res => {
                    this.setState({
                        ...this.state, 
                        syncing_field_move : false, 
                        syncing_field_move_error : false, 
                        syncing_field_complete : true, 
                        backdrop_enable : true,
                        syncing_field : null 
                    }, () => {
                        console.log("IFC :: Succesfully moved the field")
                        let refresh_action_list = ['get_groups', 'get_global_fields']
            
                        if (this.state.group_in_focus !== null) {
                            let required_actions = ['get_group_in_focus', 'get_nearby_groups_for_group', 'get_nearby_fields_for_group']
                            refresh_action_list = [...refresh_action_list, ...required_actions]
                        }
            
                        if (this.state.field_in_focus !== null) {
                            let required_actions = ['get_nearby_groups_for_field', 'get_nearby_fields_for_field']
                            refresh_action_list = [...refresh_action_list, ...required_actions]
                        }
            
                        if (this.state.search_results !== null) {
                            let required_actions = ['search']
                            refresh_action_list = [...refresh_action_list, ...required_actions]
                        }
                        console.log("IFC :: Refresh Actions : ", refresh_action_list)
                        this.refreshReportInfo(() => this.refreshData(refresh_action_list))
                    })
                }).catch(err => {
                    this.setState({...prev_state, syncing_field_move_error : true, syncing_field_complete : false, backdrop_enable : false })
                })
            }
        })
    }

    makeFieldSingleton = (field_data) => {
        console.log("IFC :: Making Singleton : ", field_data)
        let prev_state = clone(this.state)
        this.setState({
            ...this.state,
            syncing_field_move : true,
            syncing_field_move_error : false,
            syncing_field_complete : false,
            syncing_field : field_data.field_data.field,
            moving_field_from : field_data, 
            moving_field : field_data.field_data.field, 
            moving_field_to : {
                group_data : {
                    group_id : 'singletons'
                }
            }, 
            workspace_refreshed : false,
            backdrop_enable : true
        }, () => {
            Action('http_request', {
                url : "/sainapse/ifc/update_groups",
                method : "post",
                data : {
                    ic_name : this.props.ic_name,
                    version : this.props.version,
                    updates : [
                        {
                            from : field_data.field_data.group_id,
                            name : field_data.field_data.field,
                            to : 'singletons'
                        }
                    ]
                }
            }).then(res => {
                this.setState({
                    ...this.state, 
                    syncing_field_move : false, 
                    syncing_field_move_error : false, 
                    syncing_field_complete : true, 
                    syncing_field : null 
                }, () => {
                    console.log("IFC :: Succesfully moved the field")
                    let refresh_action_list = ['get_groups', 'get_global_fields']
        
                    if (this.state.group_in_focus !== null) {
                        let required_actions = ['get_group_in_focus', 'get_nearby_groups_for_group', 'get_nearby_fields_for_group']
                        refresh_action_list = [...refresh_action_list, ...required_actions]
                    }
        
                    if (this.state.field_in_focus !== null) {
                        let required_actions = ['get_nearby_groups_for_field', 'get_nearby_fields_for_field']
                        refresh_action_list = [...refresh_action_list, ...required_actions]
                    }
        
                    if (this.state.search_results !== null) {
                        let required_actions = ['search']
                        refresh_action_list = [...refresh_action_list, ...required_actions]
                    }
                    console.log("IFC :: Refresh Actions : ", refresh_action_list)
                    this.refreshReportInfo(() => this.refreshData(refresh_action_list))
                })
            }).catch(err => {
                this.setState({...prev_state, syncing_field_move_error : true, syncing_field_complete : false, backdrop_enable : false })
            })
        })
    }

    refreshData = (refresh_action_list) => {
        this.setState({...this.state, workspace_refreshed : false, workspace_refreshing : true, backdrop_enable : true}, () => {
            let api_request_list = refresh_action_list.map(action => {
                return this.getAPIObject(action)
            })
            Actions('http_requests', api_request_list).then(res => {
                console.log("IFC :: Refresh API result :", res)
                let new_state = clone(this.state)
                console.log("IFC :: Post Moving Field State Before Update :", this.state)
                refresh_action_list.map((action, i)=> {
                    if (action === 'get_groups') {
                        console.log("IFC :: Refresh Setting Action : ", action)
                        new_state.groups = res[i].data.result.Result
                        // if (new_state.group_in_focus !== null) {
                        //     new_state.group_in_focus = new_state.groups.find(group => group.group_id === this.state.group_in_focus.group_id)
                        // }
                    }

                    if (action === 'get_group_in_focus') {
                        new_state.group_in_focus = res[i].data.result.Result[0]
                    }

                    if (action === 'get_global_fields') {
                        new_state.global_fields = res[i].data.result.Result
                        if (new_state.global_field_in_focus) {
                            new_state.global_field_in_focus = new_state.global_fields.find(global_field => global_field.global_field === this.state.global_field_in_focus.global_field)
                        }
                    }

                    if (action === 'get_nearby_groups_for_group') {
                        console.log("IFC :: Refresh Setting Action : ", action)
                        let similar_groups = {
                            name_similarity : [],
                            value_similarity : [],
                            combined_similarity : []
                        }
    
                        similar_groups.name_similarity = res[i].data.result.Result.nearby_groups.name_similarity.map(nearby_group => {
                            let group = nearby_group.group
                            group.score = nearby_group.score
                            return group
                        })
    
                        similar_groups.value_similarity = res[i].data.result.Result.nearby_groups.value_similarity.map(nearby_group => {
                            let group = nearby_group.group
                            group.score = nearby_group.score
                            return group
                        })
    
                        similar_groups.combined_similarity = res[i].data.result.Result.nearby_groups.combined_similarity.map(nearby_group => {
                            let group = nearby_group.group
                            group.score = nearby_group.score
                            return group
                        })
                        new_state.similar_to_group_in_focus.groups = similar_groups
                    }

                    if (action === 'get_nearby_fields_for_group') {
                        console.log("IFC :: Refresh Setting Action : ", action)
                        new_state.similar_to_group_in_focus.fields = res[i].data.result.Result.nearby_grouped_fields
                        new_state.similar_to_group_in_focus.singletons = res[i].data.result.Result.nearby_singletons
                        new_state.similar_to_group_in_focus.global_fields = res[i].data.result.Result.nearby_global_fields
                        return new_state
                    }

                    if (action === 'get_nearby_groups_for_field') {
                        console.log("IFC :: Refresh Setting Action : ", action)
                        let similar_groups = {
                            name_similarity : [],
                            value_similarity : [],
                            combined_similarity : []
                        }
    
                        similar_groups.name_similarity = res[i].data.result.Result.nearby_groups.name_similarity.map(nearby_group => {
                            let group = nearby_group.group
                            group.score = nearby_group.score
                            return group
                        })
    
                        similar_groups.value_similarity = res[i].data.result.Result.nearby_groups.value_similarity.map(nearby_group => {
                            let group = nearby_group.group
                            group.score = nearby_group.score
                            return group
                        })
    
                        similar_groups.combined_similarity = res[i].data.result.Result.nearby_groups.combined_similarity.map(nearby_group => {
                            let group = nearby_group.group
                            group.score = nearby_group.score
                            return group
                        })

                        new_state.similar_to_field_in_focus.groups = similar_groups
                    }

                    if (action === 'get_nearby_fields_for_field') {
                        console.log("IFC :: Refresh Setting Action : ", action)
                        new_state.similar_to_field_in_focus.fields = res[i].data.result.Result.nearby_grouped_fields
                        new_state.similar_to_field_in_focus.singletons = res[i].data.result.Result.nearby_singletons
                        new_state.similar_to_field_in_focus.global_fields = res[i].data.result.Result.nearby_global_fields
                    }

                    if (action === 'search') {
                        console.log("IFC :: Refresh Setting Action : ", action)
                        new_state.search_results.groups = res[i].data.result.Result.groups
                        new_state.search_results.grouped_fields = res[i].data.result.Result.grouped_fields
                        new_state.search_results.singletons = res[i].data.result.Result.singletons
                        new_state.search_results.global_fields = res[i].data.result.Result.global_fields
                    }
                    console.log("IFC :: Post Moving Field State Before Setting :", new_state)
                    //let all_groups_loaded = [...new_state.groups, ...new_state.similar_to_group_in_focus.groups, ...new_state.similar_to_field_in_focus.groups, ...new_state.search_results.groups]
                    let all_groups_loaded = []
                    let singletons_loaded = []
                    refresh_action_list.map(action => {
                        if (action === 'get_groups') {
                            all_groups_loaded = [...all_groups_loaded, ...new_state.groups]
                        }
    
                        if (action === 'get_nearby_groups_for_group') {
                            all_groups_loaded = [...all_groups_loaded,
                                ...new_state.similar_to_group_in_focus.groups.name_similarity, 
                                ...new_state.similar_to_group_in_focus.groups.value_similarity,
                                ...new_state.similar_to_group_in_focus.groups.combined_similarity
                            ]
                        }
    
                        if (action === 'get_nearby_groups_for_field') {
                            all_groups_loaded = [
                                ...all_groups_loaded, 
                                ...new_state.similar_to_field_in_focus.groups.name_similarity,
                                ...new_state.similar_to_field_in_focus.groups.value_similarity,
                                ...new_state.similar_to_field_in_focus.groups.combined_similarity
                            ]
                        }

                        if (action === 'get_nearby_fields_for_group') {
                            singletons_loaded = [...singletons_loaded, 
                                ...new_state.similar_to_group_in_focus.singletons.combined_similarity
                            ]
                        }

                        if (action === 'get_nearby_fields_for_field') {
                            singletons_loaded = [ ...singletons_loaded, 
                                ...new_state.similar_to_field_in_focus.singletons.combined_similarity,                                
                                ...new_state.similar_to_field_in_focus.fields.combined_similarity,
                                ...new_state.similar_to_field_in_focus.global_fields.combined_similarity

                            ]
                        }

                        if (action === 'search') {
                            all_groups_loaded = [...all_groups_loaded, ...new_state.search_results.groups]
                            singletons_loaded = [...singletons_loaded, ...new_state.search_results.singletons]
                        }
                    })
                    
                    if (this.state.similar_group_in_focus) {
                        let similar_group_in_focus = all_groups_loaded.find(group => group.group_id === new_state.similar_group_in_focus.group_id)
                        new_state.similar_group_in_focus = similar_group_in_focus
                    }

                    if (this.state.similar_field_in_focus) {
                        let similar_field_in_focus = singletons_loaded.find(field => field.field === new_state.similar_field_in_focus.field)
                        new_state.similar_field_in_focus = similar_field_in_focus
                    }
                })
                console.log("IFC :: Post Moving Field State Before Setting :", new_state)

                this.setState({...new_state, workspace_refreshing : false,  workspace_refreshed : true, syncing_field_complete : false, backdrop_enable : false}, () => console.log("IFC :: Post Moving Field State :", this.state), () => {

                })

            }).catch(err => {
                this.setState({...this.state, backdrop_enable : true, workspace_refresh_error : true})
                console.log("IFC :: Refresh Actions error : ", err)
            })
        })
    }

    getThisReference = (path_list) => {
        if (Array.isArray(path_list)) {
            let val
            path_list.forEach((path, i) => {
                if (i === 0) {
                    if (path[0] === '$') {
                        val = this.getRange()
                    } else {
                        val = this[path]
                    }
                } else {
                    val = val[path]
                }
            })

            return val
        } else {
            return path_list
        }
    }

    getAPIObject = (action_id) => {
        let api_config = api_confs[action_id].api_conf
        let processed_api_conf = {
            url : this.getThisReference(api_config.url),
            method : this.getThisReference(api_config.method),
            data : {}
        }
        let data_keys = Object.keys(api_config.data)
        data_keys.forEach(data_key => {
            if (api_config.data[data_key][0] === 'List') {
                processed_api_conf.data[data_key] = [this.getThisReference(api_config.data[data_key][1])]
            } else {
                processed_api_conf.data[data_key] = this.getThisReference(api_config.data[data_key])
            }
        })

        return processed_api_conf
    }

    renderFloatingActions = () => {
        if (this.state.space_states[0] === 'group_detail' && this.state.space_states[1] === 'group_detail') {
            let groups = [this.state.group_in_focus, this.state.similar_group_in_focus]
            return (
                <MergeGroupsAction 
                    column_indices = {[0,1]} 
                    check_merge_groups = {() => this.setState({...this.state, checking_merge_groups: true})}
                    groups = {groups}
                />
            )
        }

        if (this.state.space_states[1] === 'field_detail' && this.state.space_states[2] === 'field_detail') {
            return (
                <Fragment>
                    {!this.state.checking_field_similarity && <FieldSimilarityAction key = {'reco-focusfield'} column_indices = {[1,2]} check_field_similarity = {(column_indices) => this.checkFieldSimilarity(column_indices)}/>}
                </Fragment>
            )
        }
        
        if (this.state.space_states[2] === 'field_detail' && this.state.space_states[3] === 'field_detail') {
            return (
                <Fragment>
                    {!this.state.checking_field_similarity && <FieldSimilarityAction key = {'focusfield-singleton'} column_indices = {[2,3]} check_field_similarity = {(column_indices) => this.checkFieldSimilarity(column_indices)}/>}
                </Fragment>
            )
        }
    }

    checkFieldSimilarity = (column_indices) => {
        this.setState({...this.state, checking_field_similarity: true, field_similarity_col_indices : column_indices})
    }

    renderFieldSimilarity = () => {
        if (this.state.space_states[1] === 'field_detail' && this.state.space_states[2] === 'field_detail' || this.state.space_states[2] === 'field_detail' && this.state.space_states[3] === 'field_detail') {
            if (this.state.checking_field_similarity) {
                let col_field_detail = this.state.field_similarity_col_indices.map(index => {
                    return this.state.space_states[index]
                })
                col_field_detail = col_field_detail.filter(col => col !== 'field_detail')
                if (col_field_detail.length === 0) {
                    let field_spaces = []
                    let fields = []
                    this.state.space_states.forEach((space, i) => {
                        if (space === 'field_detail') {
                            field_spaces.push(i)
                        }
                    })
                    field_spaces.forEach(col_index => {
                        if (col_index === 1 && this.state.similar_field_in_focus) {
                            fields.push(this.state.similar_field_in_focus.field)
                        }

                        if (col_index === 2 && this.state.field_in_focus) {
                            fields.push(this.state.field_in_focus.field)
                        }

                        if (col_index === 3 && this.state.singleton_in_focus) {
                            fields.push(this.state.singleton_in_focus.field)
                        }
                    })
                    return (
                        <FieldSimilarity
                            field_similarity_col_indices = {this.state.field_similarity_col_indices}
                            close_field_similarity = {() => this.setState({...this.state, checking_field_similarity : false, field_similarity_col_indices : null })}
                            fields = {fields}
                            ic_name = {this.props.ic_name}
                            field_display_name = {this.props.field_display_name}
                        />
                    )
                }
            }
        }
    }

    renderMergeGroups = () => {
        if (this.state.space_states[0] === 'group_detail' && this.state.space_states[1] === 'group_detail') {
            if (this.state.checking_merge_groups) {
                let groups = [this.state.group_in_focus, this.state.similar_group_in_focus]
                return (
                    <MergeGroup
                        groups = {groups}
                        pinned_groups = {this.state.pinned_groups}
                        group_display_name = {this.props.group_display_name}
                        ic_name = {this.props.ic_name}
                        version = {this.props.version}
                        cancel_merge = {() => this.setState({...this.state, checking_merge_groups : false})}
                        confirm_merge = {(state_obj) => this.confirmMergeGroups(state_obj)}
                        refresh_report = {(chained_func) => this.refreshReportInfo(chained_func)}
                        backdrop_enabler = {(backdrop_enable) => this.setState({...this.state, backdrop_enable : backdrop_enable})}

                    />
                )
            }
        }
    }

    confirmMergeGroups = (state_object) => {
        let space_states = [...this.state.space_states]
        space_states[1] = null
        
        this.setState({...this.state, checking_merge_groups : false, similar_group_in_focus : null, ...state_object}, () => {
            console.log("IFC :: State prior to refreshing post merge : ", this.state)
            let refresh_action_list = ['get_groups', 'get_global_fields']
            
            if (this.state.group_in_focus !== null) {
                let required_actions = ['get_group_in_focus', 'get_nearby_groups_for_group', 'get_nearby_fields_for_group']
                refresh_action_list = [...refresh_action_list, ...required_actions]
            }

            if (this.state.field_in_focus !== null) {
                let required_actions = ['get_nearby_groups_for_field', 'get_nearby_fields_for_field']
                refresh_action_list = [...refresh_action_list, ...required_actions]
            }

            if (this.state.search_results !== null) {
                let required_actions = ['search']
                refresh_action_list = [...refresh_action_list, ...required_actions]
            }
            console.log("IFC :: Refresh Actions : ", refresh_action_list)
            this.refreshData(refresh_action_list)
        })
    }

    search = (search_entities, search_term) => {
        this.setState({...this.state, similar_field_in_focus : null, similar_group_in_focus : null}, () => {
            Actions('http_request', {
                url : "/sainapse/ifc/search",
                method : "post",
                data : {
                    ic_name : this.props.ic_name,
                    version : this.props.version,
                    key : search_term
                }
            }).then(res => {
                let search_results = {
                    groups: [],
                    grouped_fields : [],
                    singletons : [],
                    global_fields : []
                }
                if (search_entities === "All") {
                    search_results = res.data.result.Result
                } else {
                    search_results[search_entities] = res.data.result.Result[search_entities]
                }
                // search_results.global_fields = search_results.global_fields
                // search_results.global_fields = search_results.global_fields.map(global_field => {
                //     return {
                //         global_field : global_field.field,
                //         matching_start_index : global_field.matching_start_index,
                //         matching_end_index : global_field.matching_end_index
                //     }
                // })
                this.setState({...this.state, search_results : search_results, search_term : search_term, search_entities: search_entities})
            })
        })
    }

    cancelSearch = () => {
        this.setState({...this.state, search_results : null, search_term : null, search_entities: null})
    }

    renderSimilarGroupSnackBars = () => {
        if (this.state.error_loading_similar_group) {
            return (
                <Snackbar 
                    anchorOrigin={{ 
                        vertical : "top", 
                        horizontal : "center" 
                    }}
                    open={this.state.error_loading_similar_group} 
                    autoHideDuration={6000}
                    onClose = {() => this.setState({...this.state, error_loading_similar_group: false})}
                >
                    <Alert severity="warning">
                        Unable to load {this.state.similar_group_in_focus.group_name} from the server. Showing transient data.
                    </Alert>
                </Snackbar>
            )
        }
    }

    renderWorkSpaceSnackkBars = () => {
        return (
            <Fragment>
                {this.state.new_group_error && <Snackbar 
                    elevation = {7}
                    anchorOrigin={{ 
                        vertical : "top", 
                        horizontal : "center" 
                    }}
                    open={this.state.new_group_error} 
                    autoHideDuration={6000}
                >
                    <Alert severity="error">
                        {"New group error : " + this.state.new_group_error_message}
                    </Alert>
                </Snackbar>}
                {this.state.syncing_field_move && <Snackbar 
                    elevation = {7}
                    anchorOrigin={{ 
                        vertical : "top", 
                        horizontal : "center" 
                    }}
                    open={this.state.syncing_field_move} 
                    autoHideDuration={6000}
                >
                    <Alert severity="info">
                        Syncing...
                    </Alert>
                </Snackbar>}
                {this.state.syncing_field_move_error && <Snackbar 
                    elevation = {7}
                    anchorOrigin={{ 
                        vertical : "top", 
                        horizontal : "center" 
                    }}
                    open={this.state.syncing_field_move_error} 
                    autoHideDuration={6000}
                    onClose = {() => this.setState({...this.state, syncing_field_move_error : false})}
                >
                    <Alert severity="error">
                        Field Move failed. 
                    </Alert>
                </Snackbar>}
                {this.state.syncing_field_complete && <Snackbar 
                    elevation = {7}
                    anchorOrigin={{ 
                        vertical : "top", 
                        horizontal : "center" 
                    }}
                    open={this.state.syncing_field_complete} 
                    autoHideDuration={6000}
                    onClose = {() => this.setState({...this.state, syncing_field_complete : false})}
                >
                    <Alert severity="success">
                        Field Move Success: {this.state.moving_field} <em>movement from</em> {this.state.moving_field_from.field_data.group_id} <em>to</em> {this.state.moving_field_to.group_data.group_name} has succeeded.
                    </Alert>
                </Snackbar>}
                {this.state.workspace_refreshed && <Snackbar 
                    elevation = {7}
                    anchorOrigin={{ 
                        vertical : "top", 
                        horizontal : "center" 
                    }}
                    open={this.state.workspace_refreshed} 
                    autoHideDuration={6000}
                    onClose = {() => this.setState({...this.state, workspace_refreshed : false})}
                >
                    <Alert severity="success">
                        Workspace refreshed.
                    </Alert>
                </Snackbar>}
                {this.state.workspace_refresh_error && <Snackbar 
                    elevation = {7}
                    anchorOrigin={{ 
                        vertical : "top", 
                        horizontal : "center" 
                    }}
                    open={this.state.workspace_refresh_error} 
                    autoHideDuration={6000}
                    //onClose = {() => this.setState({...this.state, workspace_refresh_error : false})}
                >
                    <Alert severity="error">
                        Workspace Refresh failed. 
                    </Alert>
                </Snackbar>}
            </Fragment>
        )
    }

    closeNewGroup = () => {
        this.setState({
            ...this.state,
            new_group : {
                group_id : null,
                fields : [],
                field_scores : []
            },
            new_group_error : false,
            new_group_error_message : "",
            show_new_group : false,
            unsynced_fields : []
        })
    }

    removeFieldFromNewGroup = (field) => {
        console.log("IFC :: Removing Field : ", field)
        console.log("IFC :: New Group In State:", this.state.new_group)
        let new_group = clone(this.state.new_group)
        console.log("IFC :: New Group :", new_group)
        let field_index = new_group.fields.findIndex(field_data => field_data.field_data.field === field)
        console.log("IFC :: Removing Field Index : ", field_index)
        new_group.fields.splice(field_index, 1)
        console.log("IFC :: New Group after removing field: ", new_group)
        let unsynced_fields = [...this.state.unsynced_fields]
        let unsynced_index = unsynced_fields.findIndex(fieldname => fieldname === field)
        if (unsynced_index !== -1) {
            unsynced_fields.splice(unsynced_index, 1)
        }
        this.setState({...this.state, new_group : new_group, unsynced_fields : unsynced_fields}, () => console.log("IFC :: State after removing field from new group : ", this.state))
    }

    createNewGroup = (group_name) => {
        console.log("IFC :: Prior to New Group, Syncing Fields : ", this.state.syncing_field)
        let inputs = this.state.new_group.fields.map(field => {
            return {
                name : field.field_data.field,
                from : field.field_data.group_id
            }
        })

        this.setState({...this.state, creating_new_group : true, new_group_error : false, new_group_error_message : "", backdrop_enable : true}, () => {
            Actions ('http_request', {
                url : "/sainapse/ifc/add_groups",
                method : "post",
                data : {
                    group_name : group_name === "" ? null : group_name,
                    ic_name : this.props.ic_name,
                    version : this.props.version,
                    inputs : inputs
                }
            }).then(res => {
                console.log("IFC :: New Group Created : ", res.data.result)
                this.setState({
                    ...this.state, 
                    new_group : {
                        group_id : null,
                        fields : [],
                    },
                    creating_new_group : false,
                    show_new_group : false,
                    unsynced_fields : [],
                    syncing_field : null
                }, () => {
                    let refresh_action_list = ['get_groups', 'get_global_fields']
            
                    if (this.state.group_in_focus !== null) {
                        let required_actions = ['get_group_in_focus', 'get_nearby_groups_for_group', 'get_nearby_fields_for_group']
                        refresh_action_list = [...refresh_action_list, ...required_actions]
                    }
        
                    if (this.state.field_in_focus !== null) {
                        let required_actions = ['get_nearby_groups_for_field', 'get_nearby_fields_for_field']
                        refresh_action_list = [...refresh_action_list, ...required_actions]
                    }
        
                    if (this.state.search_results !== null) {
                        let required_actions = ['search']
                        refresh_action_list = [...refresh_action_list, ...required_actions]
                    }
                    console.log("IFC :: Refresh Actions : ", refresh_action_list)
                    this.refreshReportInfo(() => this.refreshData(refresh_action_list))
                })
            }).catch(err => {
                console.log("New Group Error : ", err.response.data)
                this.setState({...this.state, new_group_error : true, new_group_error_message : err.response.data.message, backdrop_enable : false})
            })
        })
    }

    createNewGroupFromField = (field_data) => {
        let unsynced_fields = [...this.state.unsynced_fields]
        unsynced_fields.push(field_data.field_data.field)
        let new_group = clone(this.state.new_group)
        new_group.fields.push(field_data)
        this.setState({...this.state, unsynced_fields : unsynced_fields, new_group: new_group, show_new_group : true})
    }

    renderNewGroup = () => {
        return (
            <NewGroup 
                space_height = {this.state.viewport_height}
                new_group = {this.state.new_group}
                field_in_focus = {this.state.field_in_focus}
                location = {"NewGroup"}
                focus_field = {(field_object, field_type, chained_func) => this.focusField(field_object, field_type, chained_func)}
                move_field = {(field_data, field_type, drop_result) => this.moveField(field_data, field_type, drop_result)}
                accept_field_drops = {true}
                syncing_field = {this.state.syncing_field}
                close_new_group = {this.closeNewGroup}
                unsynced_fields = {this.state.unsynced_fields}
                remove_field = {(field) => this.removeFieldFromNewGroup(field)}
                create_new_group = {(group_name) => this.createNewGroup(group_name)}
                group_filter = {this.state.group_filter}
                update_filter = {(group_filter) => this.updateFilter(group_filter)}
                new_group_error = {this.state.new_group_error}
            />
        )
    }

    deleteGroup = (group_data) => {
        this.setState({...this.state, deleting_group : group_data})
    }

    cancelDelete = () => {
        this.setState({...this.state, deleting_group : null})
    }

    confirmDelete = () => {
        console.log("IFC :: Deleting Pinned Group : ", this.state.deleting_group)
        console.log("IFC :: Pinned Groups Before Deleting : ", this.state.pinned_groups)
        let pinned_groups = [...this.state.pinned_groups]
        let pinned_group_index = pinned_groups.findIndex(group_id => group_id === this.state.deleting_group.group_id)
        if (pinned_group_index !== -1) {
            pinned_groups.splice(pinned_group_index, 1)
        }
        this.setState({...this.state, pinned_groups: pinned_groups, deleting_group : null}, () => {
            let refresh_action_list = ['get_groups']
            
            if (this.state.group_in_focus !== null) {
                let required_actions = ['get_group_in_focus', 'get_nearby_groups_for_group', 'get_nearby_fields_for_group']
                refresh_action_list = [...refresh_action_list, ...required_actions]
            }

            if (this.state.field_in_focus !== null) {
                let required_actions = ['get_nearby_groups_for_field', 'get_nearby_fields_for_field']
                refresh_action_list = [...refresh_action_list, ...required_actions]
            }

            if (this.state.search_results !== null) {
                let required_actions = ['search']
                refresh_action_list = [...refresh_action_list, ...required_actions]
            }
            console.log("IFC :: Refresh Actions : ", refresh_action_list)
            this.refreshData(refresh_action_list)
        })
    }

    closeCheckpoints = () => {
        this.setState({...this.state, show_checkpoints: false})
    }

    loadCheckpoint = (checkpoint) => {
        this.setState({...Action, backdrop_enable : true}, ()=> {
            Actions('http_request', {
                url: "/sainapse/ifc/load_checkpoint",
                method : "post",
                data : {
                    ic_name : this.props.ic_name,
                    version : this.props.version,
                    name : checkpoint.name
                }
            }).then(res => {
                this.setState({...this.state, group_in_focus : null, field_in_focus: null, search_results : null, show_checkpoints : false, pinned_groups : []}, () => {
                    let refresh_action_list = ['get_groups', 'get_global_fields']
                    this.refreshReportInfo(() => this.refreshData(refresh_action_list))
                })
            })
        })   
    }

    render() { 
        const { classes } = this.props
        return (
            <ThemeProvider theme = {blue_theme}>
                <Backdrop open = {this.state.backdrop_enable} style ={{ zIndex : zIndex.drawer + 1, color : '#fff'}}> 
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        {!this.state.workspace_refresh_error && <div style={{ align : 'center', marginBottom : '5px'}}><CircularProgress variant = 'indeterminate' color = 'inherit'/></div>}
                        {this.state.workspace_refresh_error && <Typography variant = 'body2' color = 'inherit'>Workspace Refresh failed...</Typography>}
                        {this.state.workspace_refresh_error && <Typography variant = 'body2' color = 'inherit'>Please refresh your browser window</Typography>}
                    </div> 
                </Backdrop>
                <div>
                    <Checkpoints 
                        open = {this.state.show_checkpoints} 
                        close = {this.closeCheckpoints} 
                        ic_name = {this.props.ic_name} 
                        version = {this.props.version}
                        load_checkpoint = {(checkpoint) => this.loadCheckpoint(checkpoint)}
                    />
                    {(this.state.syncing_field_move) && <div style = {{width : '100vw', height : 'calc(100vh - 100px)', position : 'fixed', zIndex : 15, backgroundColor : 'rgba(0,0,0,0)'}}></div>}
                    {this.renderFloatingActions()}
                    {this.renderSimilarGroupSnackBars()}
                    {this.renderWorkSpaceSnackkBars()}
                    {this.renderFieldSimilarity()}
                    {this.renderMergeGroups()}
                    {this.state.show_new_group && this.renderNewGroup()}
                    <div
                        ref = {this.header} 
                        style = {{
                            width : '100%', 
                            height : '50px',
                        }}
                    >
                        <Paper 
                            elevation = {2}
                            square
                            style = {{
                                width : '100%', 
                                height : '47px',
                                margin: 0,
                                padding : 0,
                                display : 'flex',
                                flexDirection : 'row'
                            }}
                        >
                            <div style = {{width : '25%', height : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center', paddingLeft: '10px'}}>
                                <Typography variant = 'subtitle1' color = 'primary'>Intelligent Field Consolidation</Typography>
                            </div>
                            <div style = {{width : '25%', height : '100%', padding : '5px'}}>
                                <SearchBox make_search = {(search_entities, search_term) => this.search(search_entities, search_term)} cancel_search = {() => this.cancelSearch()}/>
                            </div>  
                            <div style = {{width : '25%', height : '100%'}}></div>  
                            <div style = {{width : '25%', height : '100%', display : 'flex', flexDirection : 'row-reverse', alignItems : 'center'}}>
                                <Button
                                    color = 'primary'
                                    onClick = {() => this.props.close_n_complete(this.props.ic_name, this.props.version)}
                                >
                                    Close and Complete
                                </Button>
                                <Button
                                    color = 'primary'
                                    onClick = {this.props.close_report}
                                >
                                    Close
                                </Button>
                                <Button
                                    color = 'primary'
                                    onClick = {() => this.setState({...this.state, show_checkpoints : true})}
                                >
                                    Checkpoints
                                </Button>
                            </div>  
                        </Paper>
                    </div>
                    {this.renderSpaces()}
                </div>
                <DeleteGroup 
                    ic_name = {this.props.ic_name}
                    version = {this.props.version}
                    deleting_group = {this.state.deleting_group} 
                    group_display_name = {this.props.group_display_name}
                    cancel_delete = {this.cancelDelete}
                    delete_group = {(group_data) => this.deleteGroup(group_data)}
                    confirm_delete = {this.confirmDelete}
                    refresh_report = {(chained_func) => this.refreshReportInfo(chained_func)}
                />
            </ThemeProvider>
        );
    }
}

export default withStyles(styles)(Report);